/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  BaseResponsePushNotificationCountResponse,
  BaseResponseSliceResponsePushNotificationResponse,
  BaseResponseString,
  GetPushNotificationPageParams,
  GetUnreadPushNotificationCountParams,
} from './data-contracts';
import {HttpClient, RequestParams} from './http-client';

export class PushNotification<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * @description 푸시 알림을 리스트 형태로 조회합니다.
   *
   * @tags PushNotification
   * @name GetPushNotificationPage
   * @summary 푸시 알림 리스트 조회
   * @request GET:/app/push-notificaitons
   * @secure
   * @response `200` `BaseResponseSliceResponsePushNotificationResponse` OK
   * @response `400` `void` 잘못된 요청 값
   * @response `401` `void` 인증되지 않음
   * @response `403` `void` 리소스 접근 권한 없음
   * @response `404` `void` 존재하지 않는 리소스
   * @response `500` `void` 서버 내부 에러
   */

  getPushNotificationPageKey = (query: GetPushNotificationPageParams) => ['app', 'push-notificaitons', query];

  getPushNotificationPage = async (query: GetPushNotificationPageParams, params: RequestParams = {}) => {
    const response = await this.http.request<BaseResponseSliceResponsePushNotificationResponse, void>({
      path: `/app/push-notificaitons`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

    return response;
  };

  /**
   * @description 푸시 알림을 모두 읽음 처리합니다.
   *
   * @tags PushNotification
   * @name UpdatePushNotifications
   * @summary 푸시 알림 모두 읽음 처리
   * @request PATCH:/app/push-notificaitons
   * @secure
   * @response `200` `BaseResponseString` OK
   * @response `400` `void` 잘못된 요청 값
   * @response `401` `void` 인증되지 않음
   * @response `403` `void` 리소스 접근 권한 없음
   * @response `404` `void` 존재하지 않는 리소스
   * @response `500` `void` 서버 내부 에러
   */

  updatePushNotifications = async (params: RequestParams = {}) => {
    const response = await this.http.request<BaseResponseString, void>({
      path: `/app/push-notificaitons`,
      method: 'PATCH',
      secure: true,
      format: 'json',
      ...params,
    });

    return response;
  };

  /**
   * @description 푸시 알림을 읽음 처리합니다.
   *
   * @tags PushNotification
   * @name UpdatePushNotification
   * @summary 푸시 알림 읽음 처리
   * @request PATCH:/app/push-notificaitons/{pushNotificationId}
   * @secure
   * @response `200` `BaseResponseString` OK
   * @response `400` `void` 잘못된 요청 값
   * @response `401` `void` 인증되지 않음
   * @response `403` `void` 리소스 접근 권한 없음
   * @response `404` `void` 존재하지 않는 리소스
   * @response `500` `void` 서버 내부 에러
   */

  updatePushNotification = async (pushNotificationId: number, params: RequestParams = {}) => {
    const response = await this.http.request<BaseResponseString, void>({
      path: `/app/push-notificaitons/${pushNotificationId}`,
      method: 'PATCH',
      secure: true,
      format: 'json',
      ...params,
    });

    return response;
  };

  /**
   * @description 읽지 않은 푸시 알림의 갯수를 조회합니다.
   *
   * @tags PushNotification
   * @name GetUnreadPushNotificationCount
   * @summary 읽지 않은 푸시 알림 갯수 조회
   * @request GET:/app/push-notificaitons/badge
   * @secure
   * @response `200` `BaseResponsePushNotificationCountResponse` OK
   * @response `400` `void` 잘못된 요청 값
   * @response `401` `void` 인증되지 않음
   * @response `403` `void` 리소스 접근 권한 없음
   * @response `404` `void` 존재하지 않는 리소스
   * @response `500` `void` 서버 내부 에러
   */

  getUnreadPushNotificationCountKey = (query: GetUnreadPushNotificationCountParams) => [
    'app',
    'push-notificaitons',
    'badge',
    query,
  ];

  getUnreadPushNotificationCount = async (query: GetUnreadPushNotificationCountParams, params: RequestParams = {}) => {
    const response = await this.http.request<BaseResponsePushNotificationCountResponse, void>({
      path: `/app/push-notificaitons/badge`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

    return response;
  };
}
